import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory, Link } from 'react-router-dom';
import PostFeaturedStyles from './PostFeatured.styled';
import Picture from '../Shared/Picture';
import Category from '../Shared/Category';
import ArrowLink from '../Shared/Link';
import theme from '../../styles/theme';
import { useInView } from 'react-intersection-observer';
import noop from '../../util/noop';
import createClassList from '../../util/createClassList';

const defaultThumbnail =
  'https://images.ctfassets.net/y64yks2od8ab/3UefaL6DWW86Zf2Hea0yEt/e3281a883561105a363b6bbe05c3ead0/defaultPost.jpg';

const PostFeatured = ({
  title = '',
  thumbnail = defaultThumbnail,
  contentTag = '',
  category = '',
  slug = '',
  excerpt = '',
  isAnimated = true,
  onImageClick = noop,
  onLinkClick = noop,
  linkClassName = '',
}) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.25,
  });
  const history = useHistory();
  const handleImageClick = () => {
    onImageClick();
    history.push(slug);
  };

  return (
    <PostFeaturedStyles
      ref={ref}
      className={`block-featured_post ${isAnimated ? 'isAnimated' : ''} ${
        inView ? 'active' : ''
      }`}
    >
      <div className='inner'>
        <div className='thumbnail'>
          <a href={slug}>
            <Picture
              src={`${thumbnail}?w=595`}
              alt={`${title} post image`}
              sources={[
                {
                  media: '(min-width: 992px)',
                  params: '?w=595',
                  srcSet: thumbnail,
                },
                {
                  media: '(min-width: 512px)',
                  params: '?w=512',
                  srcSet: thumbnail,
                },
                {
                  media: '(max-width: 512px)',
                  params: '?w=300',
                  srcSet: thumbnail,
                },
              ]}
              isResponsive
            />
          </a>
        </div>
        <div className='data'>
          {category && <Category slug={contentTag} category={category} />}
          <a
            className={createClassList('title type-h2', linkClassName)}
            href={`${slug}`}
            onClick={onLinkClick}
          >
            {title}
          </a>
          <p className='excerpt'>{excerpt}</p>
          <ArrowLink
            to={`${slug}`}
            aria-label={`View ${title}`}
            tabIndex='-1'
            className={createClassList('type-p', linkClassName)}
            onClick={onLinkClick}
          >
            View
          </ArrowLink>
        </div>
      </div>
    </PostFeaturedStyles>
  );
};

PostFeatured.propTypes = {};

export default PostFeatured;
